import { Box } from '@mui/material';
import useCopyMode from '../../hooks/useCopyMode';
import usePlanningEntity from '../../hooks/usePlanningEntity';
import { ZoomLevel } from '../../components/Header/ZoomLevelMenu';
import { useNavParams, useSelector } from '../../../../../hooks';
import { View } from '../../enums';
import { ORANGE } from 'constants/colors';
import { Icon } from '@sdb/planning-ui';

interface EventPlaceHolderProps {
  date: string;
  organizationalUnitId?: number;
  workPlaceEntityId?: string;
  projectEntityId?: string;
}

const EventPlaceholder = ({
  date,
  organizationalUnitId,
  workPlaceEntityId,
  projectEntityId
}: EventPlaceHolderProps) => {
  const { params } = useNavParams();
  const view = params?.view as View;

  const { isCopyMode, pasteAppointment } = useCopyMode();
  const [planningEntityTypePreference] = usePlanningEntity();
  const planningEntityType = planningEntityTypePreference[view];
  const { defaultZoomLevel } = useSelector((state) => state.preferences);
  const zoomLevel = defaultZoomLevel ?? ZoomLevel.STANDARD;
  return (
    <Box
      sx={{
        display: 'grid',
        placeItems: 'center',
        boxSizing: 'border-box',
        minHeight: zoomLevel !== ZoomLevel.COMPACT ? 54 : 30,
        padding: 0,
        border: '1px dashed #EFEFEF',
        borderRadius: '4px',
        cursor:
          (planningEntityType === 'WORKPLACE' ||
            planningEntityType === 'PROJECT') &&
          isCopyMode
            ? 'pointer'
            : 'auto',
        '&:hover': {
          ...((projectEntityId || workPlaceEntityId) &&
            isCopyMode && {
              outline: `2px dashed ${ORANGE}`,
              svg: {
                color: ORANGE
              }
            })
        }
      }}
      onClick={() => {
        if (
          isCopyMode &&
          planningEntityType === 'WORKPLACE' &&
          workPlaceEntityId
        ) {
          pasteAppointment({
            workPlaceEntityId: workPlaceEntityId as string,
            startDate: date
          });
        } else if (
          isCopyMode &&
          planningEntityType === 'PROJECT' &&
          projectEntityId
        ) {
          pasteAppointment({
            organizationalUnitId,
            projectEntityId: projectEntityId as string,
            startDate: date
          });
        }
      }}
    >
      {isCopyMode && (
        <Icon
          type="circle-plus"
          sx={{
            color: 'rgba(0,0,0,0.12)',
            fontSize: '20px',
            padding: 0
          }}
        />
      )}
    </Box>
  );
};

export default EventPlaceholder;
